document.addEventListener('DOMContentLoaded', function() {
  
  let prologueModal = document.getElementById("prologue");
  let doorModal = document.getElementById("door");
  let prologueBtn = document.getElementById("prologuePoint");
  let doorBtn = document.getElementById("doorPoint");
  let moonModal = document.getElementById("moon");
  let moonBtn = document.getElementById("moonPoint");
  let moonOpen = document.getElementById("moon_open");
  let moonHide = document.getElementById("moon_hide");
  let windowPoint = document.getElementById("windowPoint");
  let windowOpen = document.getElementById("window_open");
  let prologueCloseBtn = prologueModal.querySelector(".close");
  let doorCloseBtn = doorModal.querySelector(".close");
  let moonCloseBtn = moonModal.querySelector(".close");
  let letterModal = document.getElementById("letter");
  let letterBtn = document.getElementById("letterPoint");
  let letterCloseBtn = letterModal.querySelector(".close");
  let passwordModal = document.getElementById("passwordModal");
  let passwordInput = document.getElementById("passwordInput");
  let passwordCloseBtn = passwordModal.querySelector(".close");
  let submitPasswordBtn = document.getElementById("submitPassword");
  let errorMessage = document.getElementById("errorMessage");
  let letterOpen = document.getElementById("letter_open");

  let swiperInstancePrologue, swiperInstanceDoor, swiperInstanceLetter;  // Declare swiperInstanceLetter here
  let doorClickCount = 0;  // doorPointのクリック回数を記録

  // モーダル表示アニメーション
  function showModal(modal, swiperClass, swiperInstance) {
    modal.querySelector('.modal-content').style.opacity = "0";
    modal.querySelector('.modal-content').style.transform = "scale(0.7)";
    
    modal.style.display = "block";  // モーダルを表示
    
    setTimeout(function() {
      modal.style.opacity = "1";  // フェードイン
      modal.querySelector('.modal-content').style.opacity = "1";
      modal.querySelector('.modal-content').style.transform = "scale(1)";
      
      // Swiperの再初期化
      if (!swiperInstance) {
        swiperInstance = new Swiper(swiperClass, {
          direction: 'horizontal',
          slidesPerView: 1.3,
          spaceBetween: 50,
          breakpoints: {
            768: {
              slidesPerView: 2.5, // 768px以上では2枚表示
              spaceBetween: 80, // 768px以上ではスライド間の余白を20pxに
            }
          },
          freeMode: true,
          centeredSlides: true,
          //loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });
      } else {
        swiperInstance.update();  // 既存インスタンスの更新
      }
    }, 50);  // 遅延を入れてアニメーションをトリガー
  }

  // prologuePointをクリックしてprologueモーダルを表示
  prologueBtn.onclick = function() {
    showModal(prologueModal, '.prologue-swiper', swiperInstancePrologue);
  };

  // doorPointをクリックして処理を実行
  doorBtn.onclick = function() {
    doorClickCount++;
    
    if (doorClickCount === 2) {
      // 2回目のクリックでモーダルを表示
      const doorOpen = document.querySelector(".door_open");
      if (doorOpen) {
        doorOpen.style.display = "block";
        doorOpen.style.opacity = 1;// door_openを表示
      }
      setTimeout(function() {
        showModal(doorModal, '.door-swiper', swiperInstanceDoor);
        doorClickCount = 0;  // カウントをリセット
      }, 500);
    }

    // 一定時間内に2回クリックしなければカウントリセット
    setTimeout(function() {
      doorClickCount = 0;
      const doorOpen = document.querySelector(".door_open");
      if (doorOpen) {
        doorOpen.style.display = "none";
        doorOpen.style.opacity = 0;// カウントリセット時にdoor_openを非表示
      }
    }, 1000);  // 1秒間以内にクリックが必要
  };

  // moonPointをクリックして処理を実行
  moonBtn.onclick = function() {

    moonOpen.classList.add('open_moon');

    // 一定時間内に2回クリックしなければカウントリセット
    setTimeout(function() {
      showModal(moonModal, '.moon-swiper', swiperInstanceDoor);
    }, 800);  // 1秒間以内にクリックが必要
  };

  // モーダルを閉じる処理
  if (prologueCloseBtn) {
    prologueCloseBtn.onclick = function() {
      closeModal(prologueModal);
    };
  }
  if (doorCloseBtn) {
    doorCloseBtn.onclick = function() {
      closeModal(doorModal);
    };
  }
  if (passwordCloseBtn) {
    passwordCloseBtn.onclick = function() {
      closeModal(passwordModal);
    };
  }
  if (letterCloseBtn) {
    letterCloseBtn.onclick = function() {
      closeModal(letterModal);
      letterOpen.style.display = "none";
      letterOpen.style.opacity = "0";
      letterOpen.style.display = "none";
      letterOpen.style.opacity = "0";
    };
  }
  if (moonCloseBtn) {
    moonCloseBtn.onclick = function() {
      closeModal(moonModal);
      moonOpen.classList.remove('open_moon');
    };
  }

  function closeModal(modal) {
    modal.style.opacity = "0";
    modal.querySelector('.modal-content').style.opacity = "0";
    modal.querySelector('.modal-content').style.transform = "scale(0.7)";
    
    setTimeout(function() {
      modal.style.display = "none";  // 非表示にする
    }, 500);
  }

  // モーダル外をクリックした場合の閉じる処理
  window.onclick = function(event) {
    if (event.target === prologueModal) {
      closeModal(prologueModal);
    }
    if (event.target === doorModal) {
      closeModal(doorModal);
    }
    if (event.target === passwordModal) {
      closeModal(passwordModal);
      letterOpen.style.display = "none";
      letterOpen.style.opacity = "0";
    }
    if (event.target === letterModal) {
      closeModal(letterModal);
      letterOpen.style.display = "none";
      letterOpen.style.opacity = "0";
    }
    if (event.target === moonModal) {
      closeModal(moonModal);
      moonOpen.classList.remove('open_moon');
    }
  };

  // Password validation function
  function validatePassword(password) {
    const correctPassword = "munasawagi"; // Set the correct password here
    return password === correctPassword;
  }

  // Show the password modal when letterPoint is clicked
  letterBtn.onclick = function() {
    passwordModal.querySelector('.modal-content').style.opacity = "0";
    passwordModal.querySelector('.modal-content').style.transform = "scale(0.7)";

    setTimeout(function() {
      letterOpen.style.display = "block";
      letterOpen.style.opacity = "1";
    }, 50);  // 遅延を入れてアニメーションをトリガー
    
    passwordModal.style.display = "block";  // モーダルを表示
    
    setTimeout(function() {
      passwordModal.style.opacity = "1";  // フェードイン
      passwordModal.querySelector('.modal-content').style.opacity = "1";
      passwordModal.querySelector('.modal-content').style.transform = "scale(1)";
    }, 400);  // 遅延を入れてアニメーションをトリガー
  };

  // Handle password submission
  submitPasswordBtn.onclick = function() {
    const enteredPassword = passwordInput.value;

    if (validatePassword(enteredPassword)) {
      // Close the password modal and open the letter modal if password is correct
      closeModal(passwordModal);
      showModal(letterModal, '.letter-swiper', swiperInstanceLetter);  // Corrected swiperInstanceLetter usage
      errorMessage.style.display = "none"; // Hide error message if it was previously displayed
    } else {
      // Show an error message if the password is incorrect
      errorMessage.style.display = "block";
    }
  }
  
  windowPoint.onclick = function() {
    if (windowOpen.style.display === "block") {
      // If window_open is currently visible, hide it
      windowOpen.style.opacity = "0"; // Fade out effect
      setTimeout(function() {
        windowOpen.style.display = "none"; // Hide the element after the fade out
      }, 300); // Match this duration with your CSS transition duration
    } else {
      // If window_open is currently hidden, show it
      windowOpen.style.display = "block"; // Show the element
      setTimeout(function() {
        windowOpen.style.opacity = "1"; // Fade in effect
      }, 50); // Delay to trigger opacity transition
    }
  };

  function handleMediaQueryChange(event) {
    if (event.matches) {
      window.onload = function() {
        const scrollableElement = document.querySelector('.gimmick_wrap');
        const scrollWidth = scrollableElement.scrollWidth; // 全体のスクロール幅
        const clientWidth = scrollableElement.clientWidth; // 表示されている幅
        const scrollLeftValue = (scrollWidth - clientWidth) * 0.5; // 10% のスクロール位置を計算
        scrollableElement.scrollLeft = scrollLeftValue; // 左から10%の位置にスクロール
      }
    }
  }
  // メディアクエリを作成
  const mediaQuery = window.matchMedia('(max-width: 800px)');
  
  // 初回ロード時にメディアクエリをチェックして対応
  handleMediaQueryChange(mediaQuery);
  
  // 画面のサイズが変更された時にもチェックして実行
  mediaQuery.addListener(handleMediaQueryChange); // 古いブラウザ用
  mediaQuery.addEventListener('change', handleMediaQueryChange); // 新しいブラウザ用

const body = document.getElementsByTagName('body')[0];
let scrollTop = 0;
scrollTop = window.scrollY;
body.style.top = (scrollTop * -1) + 'px';
body.classList.add('no_scroll');
  

});